<template>
  <div class="main">
    <div class="back" @click="router.push('/carManage/cars')"> <a-button type="primary"><i
        class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button></div>

    <div class="form-container">
      <!-- 左侧导航 -->
      <div class="left-nav">
        <a-menu
            v-model:selectedKeys="selectedMenuKey"
            mode="inline"
            style="height: 100%; border-right: 0;"
        >
          <a-menu-item key="basicInfo">
            <h4>基本信息</h4>
          </a-menu-item>
          <a-menu-item key="licenseInfo">
            <h4>牌照信息</h4>
          </a-menu-item>
        </a-menu>
      </div>

      <!-- 右侧表单内容 -->
      <div class="form-content">
        <!-- 基本信息表单 -->
        <div v-if="selectedMenuKey[0] === 'basicInfo'" class="form-section">
          <h3 class="form-title">车辆基本信息</h3>
          <a-form style="width: 60%;margin: 0 auto;" ref="basicFormRef" :model="basicForm" name="basic" :rules="basicRules" :label-col="{ span: 7 }"
                  :wrapper-col="{ span: 18 }">
            <a-form-item label="所属企业" :name="userStore.roles.includes('carEnterprise') ? deptIdStr : ''"
                         v-hasRole="['common']">
              <a-select v-model:value="basicForm.deptIdStr" placeholder="请输入" style="width: 100%">
                <template v-for="item in deptList" :key="item.id">
                  <a-select-option :value="item.id">{{ item.name }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="车辆品牌" name="carBrand">
              <a-input v-model:value="basicForm.carBrand" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="车辆型号" name="carModel">
              <a-input v-model:value="basicForm.carModel" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="车辆颜色" name="carColor">
              <a-select ref="select" v-model:value="basicForm.carColor" placeholder="请选择">
                <template v-for="item in fuselageColorList" :key="item.dataCode">
                  <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="车辆类型" name="carType">
              <a-auto-complete v-model:value="basicForm.carType" @select="completeSelect" :options="carTypeList"
                               placeholder="请选择" :filter-option="filterOption">
                <template #option="item">
                  {{ item.value }}
                </template>
              </a-auto-complete>
            </a-form-item>
            <a-form-item label="自动驾驶级别" name="dynamicDriverLevel">
              <a-select ref="select" v-model:value="basicForm.dynamicDriverLevel" placeholder="请选择">
                <template v-for="item in driverLevelList" :key="item.dataCode">
                  <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="车架号" name="frameNum">
              <a-input v-model:value="basicForm.frameNum" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="发动机号" name="engineNum">
              <a-input v-model:value="basicForm.engineNum" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="车牌颜色" name="carPlateColor">
              <a-select ref="select" v-model:value="basicForm.carPlateColor" placeholder="请选择">
                <template v-for="item in plateColorList" :key="item.dataCode">
                  <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="能耗类型" name="energyType">
              <a-input v-model:value="basicForm.energyType" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="最大容量" name="maxCapacity">
              <a-input v-model:value="basicForm.maxCapacity" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="生产日期" name="produceDateStr">
              <a-date-picker v-model:value="basicForm.produceDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                             style="width: 100%;" />
            </a-form-item>
            <a-form-item label="车辆状态" name="carStatus">
              <a-select ref="select" v-model:value="basicForm.carStatus" placeholder="请选择">
                <template v-for="item in carStatusList" :key="item.dataCode">
                  <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="最大设计总质量（kg）" name="maxDesignQuality">
              <a-input v-model:value="basicForm.maxDesignQuality" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="整车整备质量（kg）" name="totalQuality">
              <a-input v-model:value="basicForm.totalQuality" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="轴荷（kg）" name="alexLoad">
              <a-input v-model:value="basicForm.alexLoad" placeholder="请输入" />
            </a-form-item>
            <a-form-item label="额定载客人数" name="ratedPassengerCapacity">
              <a-input v-model:value="basicForm.ratedPassengerCapacity" placeholder="请输入" />
            </a-form-item>
            <div class="flexItem">
              <a-form-item label="动力型式">
                <a-input v-model:value="basicForm.dynamicModel" placeholder="请输入" />
              </a-form-item>
              <a-form-item label="生产企业">
                <a-input v-model:value="basicForm.dynamicModelManufacture" placeholder="请输入" />
              </a-form-item>
            </div>
            <div class="flexItem">
              <a-form-item label="发动机型号">
                <a-input v-model:value="basicForm.engineModel" placeholder="请输入" />
              </a-form-item>
              <a-form-item label="生产企业">
                <a-input v-model:value="basicForm.engineModelManufacture" placeholder="请输入" />
              </a-form-item>
            </div>
            <div class="flexItem">
              <a-form-item label="动力蓄电池型号">
                <a-input v-model:value="basicForm.dynamicBatteryManufacture" placeholder="请输入" />
              </a-form-item>
              <a-form-item label="生产企业">
                <a-input v-model:value="basicForm.dynamicBatteryModel" placeholder="请输入" />
              </a-form-item>
            </div>
            <div class="flexItem">
              <a-form-item label="动力电机型号">
                <a-input v-model:value="basicForm.dynamicMachineryModel" placeholder="请输入" />
              </a-form-item>
              <a-form-item label="生产企业">
                <a-input v-model:value="basicForm.dynamicMachineryManufacture" placeholder="请输入" />
              </a-form-item>
            </div>
            <a-form-item label="监管装置">
              <a-input v-model:value="computedModel" :disabled="true" />
            </a-form-item>
          </a-form>
          <div class="botmBtn">
            <a-button type="primary" class="ml10" @click="submitBasicInfo">保存基本信息</a-button>
          </div>
        </div>

        <!-- 牌照信息表单 -->
        <div v-else-if="selectedMenuKey[0] === 'licenseInfo'" class="form-section">
          <h3 class="form-title">车辆牌照信息</h3>
          <a-form style="width: 60%;margin: 0 auto;" ref="licenseFormRef" :model="licenseForm" name="license" :rules="licenseRules" :label-col="{ span: 7 }"
                  :wrapper-col="{ span: 18 }">
            <a-form-item label="车辆型号" name="testCarNum">
              <a-input disabled v-model:value="licenseForm.carInfo" />
            </a-form-item>
            <a-form-item label="车架号" name="testCarNum">
              <a-input disabled v-model:value="licenseForm.frameNum" />
            </a-form-item>
            <a-form-item label="测试牌照" name="testCarNum">
              <a-input v-model:value="licenseForm.testCarNum" placeholder="请获取资质后填写测试车牌号" />
            </a-form-item>
            <a-form-item label="牌照申领日期" name="plateApplyDateStr">
              <a-date-picker v-model:value="licenseForm.plateApplyDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                             style="width: 100%;" />
            </a-form-item>
            <a-form-item label="牌照到期日期" name="plateExpireDateStr">
              <a-date-picker v-model:value="licenseForm.plateExpireDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                             style="width: 100%;" />
            </a-form-item>
          </a-form>
<!--          <div class="botmBtn">-->
<!--            <a-button type="primary" class="ml10" @click="submitLicenseInfo">更新牌照信息</a-button>-->
<!--          </div>-->

          <!-- 牌照变更记录表格 -->
          <div class="change-record-table mt20">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <h3 class="form-title">牌照变更记录</h3>
              <a-button type="primary" @click="showUpdatePlateModal">更新牌照申请</a-button>
            </div>
            <a-table :columns="columns" :data-source="changeRecords" :pagination="false">
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'operation'">{{ record.operation === 'add' ? '新增' : '修改' }}</template>
                <template v-else-if="column.dataIndex === 'operateTime'">{{ formatDate(record.operateTime) }}</template>
              </template>
            </a-table>
          </div>

          <!-- 更新牌照弹框 -->
          <a-modal
              v-model:visible="updatePlateModalVisible"
              title="更新牌照信息"
              @ok="handleUpdatePlate"
              @cancel="updatePlateModalVisible = false"
          >
            <a-form style="width: 100%;margin: 0 auto;" ref="licenseFormRef" :model="licenseForm" name="license" :rules="licenseRules" :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 18 }">
              <a-form-item label="测试牌照" name="testCarNum">
                <a-input v-model:value="updatePlateForm.testCarNum" placeholder="请获取资质后填写测试车牌号" />
              </a-form-item>
              <a-form-item label="牌照申领日期" name="plateApplyDateStr">
                <a-date-picker v-model:value="updatePlateForm.plateApplyDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                               style="width: 100%;" />
              </a-form-item>
              <a-form-item label="牌照到期日期" name="plateExpireDateStr">
                <a-date-picker v-model:value="updatePlateForm.plateExpireDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                               style="width: 100%;" />
              </a-form-item>
            </a-form>
          </a-modal>

        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, watch, defineProps, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {addCar, editCar, detailById, carTestNumChangeList, changeCarTestNum} from "@/api/car/car.js";
import { getList } from '@/api/enterprise/index'
import useAppStore from "@/store/modules/app";
import useUserStore from '@/store/modules/user'
import { message } from 'ant-design-vue';
import { getSingleTypeValue, getSingleTypeCode } from "@/utils/matchDic.js";

const router = useRouter()
const route = useRoute()
const appStore = useAppStore();
const userStore = useUserStore();

// 导航状态
const selectedMenuKey = ref(['basicInfo']);

// 表单引用
const basicFormRef = ref();
const licenseFormRef = ref();

// 拆分表单数据
const basicForm = ref({
  deptIdStr: null,
  carBrand: "",
  carModel: "",
  carColor: null,
  carType: "",
  dynamicDriverLevel: null,
  frameNum: "",
  engineNum: "",
  carPlateColor: null,
  energyType: "",
  maxCapacity: "",
  produceDateStr: "",
  carStatus: null,
  maxDesignQuality: "",
  totalQuality: "",
  alexLoad: "",
  ratedPassengerCapacity: "",
  dynamicModel: "",
  dynamicModelManufacture: "",
  engineModel: "",
  engineModelManufacture: "",
  dynamicBatteryManufacture: "",
  dynamicBatteryModel: "",
  dynamicMachineryModel: "",
  dynamicMachineryManufacture: "",
  monitorDeviceId: "",
});

const licenseForm = ref({
  carBrand: "",
  carModel: "",
  carColor: null,
  carInfo: "",
  frameNum: "",
  testCarNum: '',
  plateReviewStatus: 0,
  plateApplyDateStr: '',
  plateExpireDateStr: '',
});

// 添加更新牌照相关数据
const updatePlateModalVisible = ref(false);
const updatePlateFormRef = ref(null);
const updatePlateForm = ref({
  testCarNum: '',
  plateApplyDateStr: '',
  plateExpireDateStr: ''
});
const updatePlateRules = ref({
  testCarNum: [{ required: true, message: '请输入测试牌照', trigger: 'blur' }],
  plateApplyDateStr: [{ required: true, message: '请选择牌照申领日期', trigger: 'change' }],
  plateExpireDateStr: [{ required: true, message: '请选择牌照到期日期', trigger: 'change' }]
});

// 显示更新牌照弹框
const showUpdatePlateModal = () => {
  // 打开弹框前复制当前牌照信息到表单
  // updatePlateForm.value = {
  //   testCarNum: licenseForm.value.testCarNum,
  //   plateApplyDateStr: licenseForm.value.plateApplyDateStr ? licenseForm.value.plateApplyDateStr : null,
  //   plateExpireDateStr: licenseForm.value.plateExpireDateStr ? licenseForm.value.plateExpireDateStr: null
  // };
  updatePlateModalVisible.value = true;
};

// 处理更新牌照提交
const handleUpdatePlate = async () => {
  try {
    await updatePlateFormRef.value.validate();
    // 这里添加更新牌照的API调用逻辑
    const formData = {
      ...updatePlateForm.value,
      plateApplyDateStr: updatePlateForm.value.plateApplyDateStr ? updatePlateForm.value.plateApplyDateStr.format('YYYY-MM-DD') : '',
      plateExpireDateStr: updatePlateForm.value.plateExpireDateStr ? updatePlateForm.value.plateExpireDateStr.format('YYYY-MM-DD') : ''
    };
    // 调用API更新牌照
    // await updatePlateAPI(formData);
    // 更新成功后关闭弹框并刷新数据
    updatePlateModalVisible.value = false;
    // 刷新牌照信息
    // getData();
    message.success('牌照更新成功');
  } catch (error) {
    // 验证失败或API调用失败
    console.error('更新牌照失败:', error);
  }
};
const resetBasicForm = () => {
  basicForm.value = {
    deptIdStr: null,
    carBrand: "",
    carModel: "",
    carColor: null,
    carType: "",
    dynamicDriverLevel: null,
    frameNum: "",
    engineNum: "",
    carPlateColor: null,
    energyType: "",
    maxCapacity: "",
    produceDateStr: "",
    carStatus: null,
    maxDesignQuality: "",
    totalQuality: "",
    alexLoad: "",
    ratedPassengerCapacity: "",
    dynamicModel: "",
    dynamicModelManufacture: "",
    engineModel: "",
    engineModelManufacture: "",
    dynamicBatteryManufacture: "",
    dynamicBatteryModel: "",
    dynamicMachineryModel: "",
    dynamicMachineryManufacture: "",
    monitorDeviceId: "",
  }
}

const resetLicenseForm = () => {
  licenseForm.value = {
    carBrand: "",
    carModel: "",
    carColor: null,
    carInfo: "",
    frameNum: "",
    testCarNum: "",
    plateReviewStatus: undefined,
    plateApplyDateStr: "",
    plateExpireDateStr: "",
  }
}

// 表单验证规则
const basicRules = {
  deptIdStr: [
    { required: true, message: '所属企业不能为空', trigger: 'change' },
  ],
  carBrand: [
    { required: true, message: '车辆品牌不能为空', trigger: 'change' },
  ],
  name: [
    { required: true, message: '生产企业不能为空', trigger: 'change' },
  ],
  carModel: [
    { required: true, message: '车辆型号不能为空', trigger: 'change' },
  ],
  carColor: [
    { required: true, message: '车辆颜色不能为空', trigger: 'change' },
  ],
  carType: [
    { required: true, message: '车辆类型不能为空', trigger: 'change' },
  ],
  dynamicDriverLevel: [
    { required: true, message: '自动驾驶级别不能为空', trigger: 'change' },
  ],
  frameNum: [
    { required: true, message: '车架号不能为空', trigger: 'change' },
  ],
  engineNum: [
    { required: true, message: '发动机号不能为空', trigger: 'change' },
  ],
  carPlateColor: [
    { required: true, message: '车牌颜色不能为空', trigger: 'change' },
  ],
  energyType: [
    { required: true, message: '能耗类型不能为空', trigger: 'change' },
  ],
  maxCapacity: [
    { required: true, message: '最大容量不能为空', trigger: 'change' },
  ],
  produceDateStr: [
    { required: true, message: '生产日期不能为空', trigger: 'change' },
  ],
  carStatus: [
    { required: true, trigger: 'change', message: '车辆状态不能为空' },
  ],
  maxDesignQuality: [
    { required: true, trigger: 'change', message: '最大设计总质量不能为空' },
  ],
}

const licenseRules = {
  testCarNum: [
    { required: true, message: '测试牌照不能为空', trigger: 'change' },
  ],
  plateApplyDateStr: [
    { required: true, message: '牌照申领日期不能为空', trigger: 'change' },
  ],
  plateExpireDateStr: [
    { required: true, message: '牌照到期日期不能为空', trigger: 'change' },
  ],
}

// 计算属性
const computedModel = computed({
  get() {
    // 根据条件判断返回不同的值
    return basicForm.value.bindMonitorDevice == '0' ? '未安装' : basicForm.value.bindMonitorDevice == '1' ? '已安装' : '';
  },
  set(value) {
    basicForm.value.bindMonitorDevice = value;
  }
});

// 初始化数据
if (route.query.id) {
  getData(route.query.id);
  // 获取牌照变更记录
  getChangeRecords(route.query.id);
}

// 搜索选项过滤
const filterOption = (input, option) => {
  return option.value.toUpperCase().indexOf(input.toUpperCase()) >= 0;
};

const dataCodeValue = ref('')
const completeSelect = (value, option) => {
  dataCodeValue.value = option.code
}

// 部门列表
const deptList = ref([]);
function deptListAjax() {
  const query = {
    pageIndex: 1,
    pageSize: 500,
    conditionMap: {
      name: ''
    },
  };
  getList(query).then(res => {
    if (res.code === 200) {
      deptList.value = res.data.records;
    }
  })
}

deptListAjax();

// 编辑模式下获取详情
function getData(id) {
  detailById({ id: id }).then(res => {
    if (res.code === 200) {
      res.data.carType = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + res.data.carType)
      // 拆分数据到两个表单
      Object.assign(basicForm.value, res.data);
      Object.assign(licenseForm.value, {
        carInfo: res.data.carBrand + '/' + res.data.carModel,
        frameNum: res.data.frameNum,
        testCarNum: res.data.testCarNum,
        plateReviewStatus: res.data.plateReviewStatus,
        plateApplyDateStr: res.data.plateApplyDateStr,
        plateExpireDateStr: res.data.plateExpireDateStr
      });
    }
  })
}

// 获取牌照变更记录
function getChangeRecords(carId) {
  carTestNumChangeList(carId).then(res => {
    if (res.code === 200) {
      changeRecords.value = res.data;
    }
  })
}

// 提交基本信息
const submitBasicInfo = () => {
  // 车企端"deptIdStr"
  if (userStore.roles.includes('carEnterprise')) {
    basicForm.value.deptIdStr = userStore.deptId;
  }
  basicFormRef.value
      .validate()
      .then(() => {
        let obj = {...basicForm.value};
        if (dataCodeValue.value) {
          obj.carType = dataCodeValue.value
        } else {
          obj.carType = getSingleTypeCode(appStore.SysDictVOList, 'carInfo' + 'category' + obj.carType)
        }
        if (route.query.id) {
          // 更新人id
          obj.updateBystr = '';
          editCar(obj).then(res => {
            if (res.code === 200) {
              message.success('基本信息保存成功');
            }
          })
        } else {
          // 创建人id
          obj.createByStr = '';
          addCar(obj).then(res => {
            if (res.code === 200) {
              carId = res.data
              message.success('基本信息保存成功');
              // 保存成功后跳转到列表页
              // router.push('/carManage/cars')
            }
          })
        }
      })
      .catch(error => {
        console.log('error', error);
      });
}

// 提交牌照信息
const submitLicenseInfo = () => {
  licenseFormRef.value
      .validate()
      .then(() => {
        let obj = {...licenseForm.value};
        if (carId.value){
          obj.id = carId.value
          // 更新人id
          obj.updateBystr = '';
          changeCarTestNum(obj).then(res => {
            if (res.code === 200) {
              message.success('牌照信息保存成功');
              // 刷新变更记录
              getChangeRecords(carId.value);
            }
          })
        }else {
          message.warning('请先保存基本信息后再变更测试牌照信息！');
        }

      })
      .catch(error => {
        console.log('error', error);
      });
}

// 取消
const cancel = () => {
  router.push('/carManage/cars')
}

// 字典数据
const carStatusList = ref([]);
const fuselageColorList = ref([]);
const plateColorList = ref([]);
const carTypeList = ref([]);
const driverLevelList = ref([]);

let carId = ref(route.query.id);
// 牌照变更记录表格数据
const changeRecords = ref([]);
const columns = [
  { title: '变更前牌照', dataIndex: 'beforeData', key: 'beforeData' },
  { title: '变更后', dataIndex: 'afterData', key: 'afterData' },
  { title: '操作类型', dataIndex: 'operation', key: 'operation' },
  { title: '操作人', dataIndex: 'changer', key: 'changer' },
  { title: '操作时间', dataIndex: 'createTime', key: 'createTime' },
];

// 格式化日期
function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString();
}

onMounted(async () => {
  let carTypeArr = []
  carStatusList.value = await appStore.getSysDictVOList('车辆状态');
  fuselageColorList.value = await appStore.getSysDictVOList('车身颜色');
  plateColorList.value = await appStore.getSysDictVOList('车牌颜色');
  driverLevelList.value = await appStore.getSysDictVOList('自动驾驶级别');

  carTypeArr = await appStore.getSysDictVOList('车辆类型');
  carTypeArr.map(item => {
    carTypeList.value.push({
      value: item.dataValue,
      code: item.dataCode,
    })
  })
})
</script>
<style lang="less" scoped>
.main {
  padding: 5px;
  background-color: #ffffff;
  position: relative;  /* 设置相对定位，作为返回按钮的参考 */

  .back {
    position: fixed;
    top: 93px;
    right: 50px
  }

  .form-container {
    display: flex;
    margin-top: 20px;

    .left-nav {
      width: 200px;
      border-right: 1px solid #e8e8e8;
      position: sticky;  /* 设置为粘性定位 */
      top: 20px;  /* 距离顶部的距离 */
      overflow-y: auto;  /* 左侧导航自身也可滚动（如果内容过长） */

      /* 为左侧菜单添加样式 */
      /deep/ .ant-menu {
        border-right: none;
      }

      /* 增强选中项的样式 */
      /deep/ .ant-menu-item-selected {
        background-color: #e6f7ff !important;
        color: #1890ff !important;
        font-weight: bold;
      }

      /* 增强菜单项悬停效果 */
      /deep/ .ant-menu-item:hover {
        background-color: #f0f7ff;
        color: inherit !important;
      }
    }

    .form-content {
      flex: 1;
      padding: 0 20px;
      max-height: calc(100vh - 100px);
      overflow-y: auto;  /* 启用垂直滚动 */

      .form-section {
        margin: 0 auto;  // 居中显示
        background-color: #ffffff;
        //border-radius: 5px;
        //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .form-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e8e8e8;
        }

        .flexItem {
          display: flex;
          justify-content: space-around;

          /deep/.ant-form-item {
            width: 50%;

            .ant-col-6 {
              flex: 0 0 40% !important;
              max-width: 40% !important;
            }
          }
        }

        .botmBtn {
          display: flex;
          justify-content: center;
          margin-top: 30px;
        }

        .change-record-table {
          margin-top: 30px;

          .ant-table {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
/deep/.ant-input-disabled, .ant-input[disabled]{
  background: #ddd
}
</style>
